import { createMuiTheme } from '@material-ui/core/styles'
import { theme, colors } from './Global'

export default createMuiTheme({
  palette: {
    type: 'light',
    primary: {
      main: colors.govDocsBlue,
      light: colors.lightBlue,
      dark: colors.govDocsBlue,
      contrastText: colors.white
    },
    secondary: {
      main: colors.govDocsRed,
      light: colors.lightRed,
      dark: colors.govDocsRed,
      contrastText: colors.white
    },
    contrastThreshold: 3,
    tonalOffset: 0.2
  },
  shape: { borderRadius: '3px' },
  typography: {
    // Use the system font instead of the default Roboto font.
    useNextVariants: true,
    fontSize: 12,
    subtitle1: { color: theme.colors.text },
    h5: { color: theme.colors.text },
    h6: { color: theme.colors.text },
    body1: { color: theme.colors.text },
    body2: { color: `${theme.colors.text} !important` },
    fontFamily: '"Open Sans"'
  },
  overrides: {
    MuiPaper: { root: { color: colors.darkGrey } },
    MuiToolbar: {
      root: {
        backgroundColour: theme.colors.blueBackground,
        flex: 'auto'
      }
    },
    MuiListItem: {
      root: {
        color: theme.colors.whiteText,
        margin: 0
      },
      selected: {
        backgroundColor: `${colors.white} !important`,
        '&:hover': { backgroundColor: `${colors.lightGrey} !important` }
      }
    },
    MuiFormLabel: {
      root: {
        color: theme.colors.text,
        '&$focused': { color: theme.colors.text }
      }
    },
    MuiButtonBase: { root: { margin: 0 } },
    MuiTooltip: {
      tooltip: {
        fontSize: '10px',
        backgroundColor: colors.darkGrey,
        color: colors.white,
        boxShadow: '0 0 5px rgba(0,0,0,0.3)'
      }
    },
    MuiSwitch: {
      colorSecondary: {
        // .MuiSwitch-colorSecondary-307.MuiSwitch-checked-305 + .MuiSwitch-bar-309
        '&$checked + $bar': { backgroundColor: `${colors.lightGreen} !important` }
      }
    },
    MuiButton: {
      // Name of the styleSheet
      root: {
        color: colors.white,
        margin: 0,
        borderRadius: 0
      },
      raised: { boxShadow: 'unset' },
      flatPrimary: { color: colors.white },
      flatSecondary: {
        color: colors.govDocsBlue,
        hover: { backgroundColor: 'red' }
      }
    }
  }
})
